var _defs, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.345,
    height: 60.702,
    viewBox: "0 0 60.345 60.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#f);}.g{fill:url(#h);}.h{fill:url(#j);}.i{fill:url(#l);}.j{fill:url(#m);}.k{fill:url(#n);}.l{fill:url(#o);}.m{fill:url(#p);}.n{fill:url(#q);}.o{fill:url(#r);}.p{fill:url(#s);}.q{fill:url(#t);}.r{fill:url(#u);}.s{fill:url(#v);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.151,
    y1: 0.151,
    x2: 0.853,
    y2: 0.853,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.883,
    y1: 0.626,
    x2: 0.4,
    y2: 0.284,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 0.201,
    x2: 0.5,
    y2: 0.878,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.151,
    y1: 0.151,
    x2: 0.853,
    y2: 0.853,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 1.173,
    y1: 0.833,
    x2: 0.468,
    y2: 0.332,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bacdf",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    y1: 0.181,
    x2: 0.5,
    y2: 1.048,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 1.16,
    y1: 0.825,
    x2: 0.455,
    y2: 0.324,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 1.533,
    y1: 1.095,
    x2: 0.348,
    y2: 0.249,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 2.256,
    y1: 1.633,
    x2: 0.277,
    y2: 0.2,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 2.786,
    y1: 3.825,
    x2: 2.937,
    y2: 3.825,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.649,
    y1: 2.622,
    x2: 1.356,
    y2: 3.33,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#62dbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08a9f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 1.331,
    y1: 4.077,
    x2: 0.907,
    y2: 4.077,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017bae",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#02678e",
    stopOpacity: 0.631
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025f80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 1.139,
    y1: 3.143,
    x2: 1.291,
    y2: 3.143,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 1.364,
    y1: 2.246,
    x2: 1.628,
    y2: 2.246,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 2.495,
    y1: 3.932,
    x2: 2.8,
    y2: 3.932,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 3.936,
    y1: 5.787,
    x2: 3.936,
    y2: 5.405,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f02818",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#da2721",
    stopOpacity: 0.639
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 3.385,
    y1: 5.105,
    x2: 3.385,
    y2: 4.814,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 3.479,
    y1: 5.167,
    x2: 3.479,
    y2: 5.353,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 3.728,
    y1: 5.27,
    x2: 3.728,
    y2: 5.457,
    xlinkHref: "#r"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.784)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 26.78,
    cy: 26.78,
    r: 26.78,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M243.7,160.979a27.015,27.015,0,0,0,.29-38.492l-19.391,19.391Z",
    transform: "translate(-198.219 -114.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.1,331a27.023,27.023,0,0,0,52.822,0Z",
    transform: "translate(-4.852 -298.388)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 20.834,
    cy: 20.834,
    r: 20.834,
    transform: "translate(5.828 6.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M239.322,188.975a20.832,20.832,0,0,0,.29-29.746l-15.018,15.018Z",
    transform: "translate(-198.219 -147.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M58.625,331a20.841,20.841,0,0,0,40.081,0Z",
    transform: "translate(-52.004 -298.388)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.865,
    cy: 14.865,
    r: 14.865,
    transform: "translate(11.796 12.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M235.1,215.993a14.864,14.864,0,0,0,.291-21.3l-10.8,10.8Z",
    transform: "translate(-198.219 -178.301)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.353,
    cy: 8.353,
    r: 8.353,
    transform: "translate(18.308 18.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M230.494,245.467a8.353,8.353,0,0,0,.293-12.092l-6.193,6.193Z",
    transform: "translate(-198.22 -212.382)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.832,
    cy: 3.832,
    r: 3.832,
    transform: "translate(22.829 23.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M227.289,265.923a3.832,3.832,0,0,0,.3-5.691l-3,3Z",
    transform: "translate(-198.22 -236.043)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M222.659,200a.893.893,0,0,1,0-1.262l10.015-10.015a.893.893,0,0,1,1.262,1.262L223.921,200A.893.893,0,0,1,222.659,200Z",
    transform: "translate(-196.284 -166.026)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M418.657,8.227a4.114,4.114,0,0,0-4.114-4.114,4.114,4.114,0,0,0-8.227,0V8.072a4.269,4.269,0,0,0,4.269,4.269h3.958A4.113,4.113,0,0,0,418.657,8.227Z",
    transform: "translate(-387.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M416.821,41.539a4.269,4.269,0,0,0,3.019,1.25H423.8a4.114,4.114,0,0,0,0-8.227Z",
    transform: "translate(-397.207 -30.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M385.909,36.746a.893.893,0,0,1,0-1.262l10.015-10.015a.893.893,0,1,1,1.262,1.262L387.171,36.746A.893.893,0,0,1,385.909,36.746Z",
    transform: "translate(-369.744 -22.206)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M263.094,103.072c-4.811,4.811-8.156,5.142-10.015,3.282s-1.529-5.2,3.282-10.015,13.8-10.789,15.663-8.93S267.9,98.261,263.094,103.072Z",
    transform: "translate(-252.028 -76.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M263.094,168.506c-4.811,4.811-8.156,5.141-10.015,3.282s-1.528-5.2,3.282-10.015c.146-.146.295-.291.445-.437.949,1.084,2.053,2.261,3.258,3.467s2.383,2.309,3.467,3.258C263.385,168.211,263.24,168.36,263.094,168.506Z",
    transform: "translate(-252.029 -142.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M252.541,196.42l4.292,4.292a8.73,8.73,0,0,0,3.375-1.464l-6.2-6.2A8.731,8.731,0,0,0,252.541,196.42Z",
    transform: "translate(-252.48 -170.068)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M264.845,176.167l6.2,6.2a19.77,19.77,0,0,0,2.28-1.8l-6.681-6.681A19.753,19.753,0,0,0,264.845,176.167Z",
    transform: "translate(-263.32 -153.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M275.85,168.428l-.012.013a.884.884,0,0,0,0,1.178,72.2,72.2,0,0,0,6.176,6.176.884.884,0,0,0,1.178,0l.013-.012a.884.884,0,0,0,0-1.318,70.228,70.228,0,0,1-6.034-6.034A.884.884,0,0,0,275.85,168.428Z",
    transform: "translate(-272.806 -148.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M259.351,184.928l-.012.013a.884.884,0,0,0,0,1.178,72.207,72.207,0,0,0,6.176,6.176.884.884,0,0,0,1.178,0l.013-.012a.884.884,0,0,0,0-1.318,70.222,70.222,0,0,1-6.034-6.034A.884.884,0,0,0,259.351,184.928Z",
    transform: "translate(-258.271 -162.659)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.5f4ce26ca6f80845ff4306189fc528b2.svg";
export { ForwardRef as ReactComponent };